/** @format */

export const ClientEntity = {
    id: null,
    firstname: null,
    mainname: null,
    name2: null,
    fullname: null,
    street: null,
    zip: null,
    city: null,
    country: null,
    email: null,
    house: null,
    apartment: null,
    plicbd: true,
    reportPlicbd: true,
    isPrivateClient: true,
    user1: null,
    user2: null,
    externalid2: null,
    nip: null,
    pesel: null,
    regon: null,
    businessName: null,
    altStateId: null,
    altBoroughId: null,
    altDistrictId: null,
    altCityId: null,
    altStreetId: null,
    borough: null,
    district: null,
    bankaccount: null,
    contactphone: null,
    tariffId: 0,
    platformResellerId: null,
};

export const ClientEntityErrorState = {
    id: null,
    firstname: null,
    mainname: null,
    street: null,
    zip: null,
    city: null,
    country: null,
    email: null,
    house: null,
    apartment: null,
    plicbd: true,
    reportPlicbd: null,
    isPrivateClient: null,
    user1: null,
    user2: null,
    externalid2: null,
    nip: null,
    pesel: null,
    regon: null,
    businessName: null,
    altStateId: null,
    altBoroughId: null,
    altDistrictId: null,
    altCityId: null,
    altStreetId: null,
    borough: null,
    district: null,
    bankaccount: null,
    contactphone: null,
    tariffId: null,
};
